"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.versioningConfigurationSchema = exports.apiChangeArraySchema = exports.accessPolicySchema = exports.apiVersionArraySchema = exports.versionSchema = exports.UNVERSIONED_VERSION_NAME = exports.VERSION_REGEX = exports.RELEASE_VERSION_REGEX = exports.RELEASE_VERSION_REGEX_MONTH_GROUP_IDX = exports.RELEASE_VERSION_REGEX_YEAR_GROUP_IDX = exports.RELEASE_VERSION_REGEX_STRING = exports.UNSTABLE_VERSION_REGEX_STRING = void 0;
const zod_1 = __importDefault(require("zod"));
exports.UNSTABLE_VERSION_REGEX_STRING = "^unstable$";
exports.RELEASE_VERSION_REGEX_STRING = "^(\\d{4})-((0[1-9])|(1[0-2]))$";
exports.RELEASE_VERSION_REGEX_YEAR_GROUP_IDX = 1;
exports.RELEASE_VERSION_REGEX_MONTH_GROUP_IDX = 2;
exports.RELEASE_VERSION_REGEX = new RegExp(exports.RELEASE_VERSION_REGEX_STRING);
exports.VERSION_REGEX = new RegExp(`${exports.UNSTABLE_VERSION_REGEX_STRING}|${exports.RELEASE_VERSION_REGEX_STRING}`);
exports.UNVERSIONED_VERSION_NAME = "unversioned";
exports.versionSchema = zod_1.default.string().regex(exports.VERSION_REGEX);
const apiVersionPropertiesSchema = zod_1.default.object({});
const apiVersionSchema = apiVersionPropertiesSchema
    .extend({
    handle: exports.versionSchema,
})
    .strict();
exports.apiVersionArraySchema = zod_1.default.array(apiVersionSchema);
// Only allow version handles in the format of yyyy-mm or unstable
const versionStringSchema = zod_1.default.string().regex(exports.VERSION_REGEX);
exports.accessPolicySchema = zod_1.default.union([zod_1.default.literal("public"), zod_1.default.literal("private"), zod_1.default.literal("everywhere")]);
const accessRequestSchema = zod_1.default.union([zod_1.default.literal("external"), zod_1.default.literal("internal")]);
const apiChangePropertiesSchema = zod_1.default.object({
    version: versionStringSchema,
    intendedVersion: versionStringSchema.optional(),
    internalSummary: zod_1.default.string(),
    accessPolicy: exports.accessPolicySchema.default("private"),
    accessibleAsOfDate: zod_1.default.date().optional(),
    deprecatedAsOfVersion: versionStringSchema.optional(),
    removedAsOfVersion: versionStringSchema.optional(),
});
const apiChangeSchema = apiChangePropertiesSchema
    .extend({
    handle: zod_1.default.string(),
})
    .strict();
exports.apiChangeArraySchema = zod_1.default.array(apiChangeSchema);
exports.versioningConfigurationSchema = zod_1.default
    .object({
    routePrefixes: zod_1.default.array(zod_1.default.string().regex(/\/$/)).min(1),
    versions: exports.apiVersionArraySchema.transform((versionsArray) => {
        return versionsArray.reduce((apiVersions, apiVersion) => {
            // eslint-disable-next-line  @typescript-eslint/no-unused-vars
            const { handle, ...apiVersionProperties } = apiVersion;
            apiVersions[apiVersion.handle] = apiVersionProperties;
            return apiVersions;
        }, {});
    }),
    handles: exports.apiChangeArraySchema.transform((changesArray) => {
        return changesArray.reduce((apiChanges, apiChange) => {
            // eslint-disable-next-line  @typescript-eslint/no-unused-vars
            const { handle, ...apiChangeProperties } = apiChange;
            apiChanges[apiChange.handle] = apiChangeProperties;
            return apiChanges;
        }, {});
    }),
})
    .superRefine((config, ctx) => {
    const checkVersion = (ctx, version) => {
        if (version && !config.versions[version]) {
            ctx.addIssue({
                code: zod_1.default.ZodIssueCode.custom,
                message: `Version ${version} does not exist`,
            });
        }
    };
    Object.values(config.handles).forEach((properties) => {
        checkVersion(ctx, properties.version);
    });
});
//# sourceMappingURL=Versioning.js.map